import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { TerminateStakeholderItemDto } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useTerminationFinalExerciseDate = () => {
  const {
    mutate: calcTerminationFinalExerciseDate,
    isPending,
    data,
  } = useAppMutation<
    Date,
    HttpException,
    { companyId: string; data: TerminateStakeholderItemDto; vestingTaskId: string }
  >([QueryKey.CALC_FINAL_EXERCISE_DATE], {
    mutationFn: ({
      companyId,
      vestingTaskId,
      data,
    }: {
      companyId: string;
      data: TerminateStakeholderItemDto;
      vestingTaskId: string;
    }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', 'terminate', vestingTaskId],
        },
        { body: data },
      ),
  });

  return { calcTerminationFinalExerciseDate, isPending, data };
};
